import styled, { css } from 'styled-components';
import { StyledBox } from 'styles/common';

export const AbsCenterContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

export const NoDataContainer = styled.div`
  color: #888;
  font-size: 1.15rem;
  font-weight: 300;
`;

export const ActionIconContainer = styled(StyledBox)`
  display: flex;
  align-items: center;

  padding: 6px;

  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.palette.primary.main};

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${(props) => props.theme.palette.primary.main};

        svg {
          fill: white;
        }
      }
    `}
`;
